import { css } from 'aphrodite';
import { ConfirmationDialog, IConfirmationDialogOption } from '../../ConfirmationDialog';
import { WarningIcon } from '../../svgs/icons/WarningIcon';
import { styleSheet } from './styles';

interface IProps {
	isOpen: boolean;
	onClose: () => void;
	onRemove: () => void;
}

const removeRepCodeOptions: IConfirmationDialogOption<boolean>[] = [
	{
		isDestructive: true,
		representedObject: true,
		title: 'Remove',
	},
	{
		isCancel: true,
		representedObject: false,
		title: 'Cancel',
	},
];

export const RemoveRepCodeModal = ({ isOpen, onClose, onRemove }: IProps) => {
	const onRequestClose = (result?: IConfirmationDialogOption<boolean>, canceled?: boolean) => {
		if (!!result?.isDestructive && !canceled) {
			onRemove();
		}

		onClose();
	};

	return (
		<ConfirmationDialog
			icon={<WarningIcon />}
			modalProps={{
				isOpen,
				onRequestClose,
			}}
			options={removeRepCodeOptions}
			title={
				<div className={css(styleSheet.title)}>
					Remove your Rep Code? Levitate will not be able to file your marketing for compliance review until you add it
					again.
				</div>
			}
		/>
	);
};
